// extracted by mini-css-extract-plugin
export default {"videoContainer":"LessonVideo_videoContainer__heMMe"};